import imageCompression from 'browser-image-compression';

/**
 * Process an entry image for upload (posts):
 * - Converts HEIC/HEIF to JPEG
 * - Compresses to max 1 MB
 * - Resizes to max 1200px dimension (2.4x the 500px modal display)
 */
export async function processEntryImage(file: File): Promise<File> {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1200,
    fileType: 'image/jpeg' as const,
  };

  try {
    // Attempt 1: Try with Web Worker (Faster, non-blocking)
    const compressedFile = await imageCompression(file, { ...options, useWebWorker: true });
    return compressedFile;
  } catch (workerError) {
    console.warn('WebWorker compression failed, falling back to main thread:', workerError);
    
    try {
      // Attempt 2: Fallback to Main Thread (Reliable, but blocking)
      const compressedFile = await imageCompression(file, { ...options, useWebWorker: false });
      return compressedFile;
    } catch (mainThreadError) {
      // Definite Failure: Do NOT return the original file (which might be HEIC/incompatible)
      console.error('Image compression failed completely:', mainThreadError);
      throw new Error('Image processing failed');
    }
  }
}

/**
 * Process a board cover image for upload:
 * - Converts HEIC/HEIF to JPEG
 * - Compresses to max 0.5 MB
 * - Resizes to max 800px dimension (2.8x the 280px grid display)
 */
export async function processCoverImage(file: File): Promise<File> {
  const options = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 800,
    useWebWorker: true,
    fileType: 'image/jpeg' as const,
  };

  try {
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.error('Image compression failed:', error);
    return file;
  }
}
